import {ACTION_TYPES} from "./action-types";

export const setPaymentToken = (token) => ({
    type: ACTION_TYPES.SET_PAYMENT_TOKEN,
    token
});

export const setFastlane = fastlane => ({
    type: ACTION_TYPES.SET_FASTLANE,
    fastlane
});

export const setCustomerContextId = id => ({
    type: ACTION_TYPES.SET_CUSTOMER_CONTEXT,
    id
});

export const addCanceledEmail = email => ({
    type: ACTION_TYPES.ADD_CANCELED_EMAIL,
    email
})